import Controller from "./company.controller";
import template from "./company.html";

const company = {
  template,
  controller: Controller,
};

export default company;



// WEBPACK FOOTER //
// ./src/pages/company/company.component.js